// Type
export interface SelectOption {
  value: string;
  name: string;
}

export const companyNameOptions: SelectOption[] = [
  { value: 'abcSolar', name: 'ABC Solar' },
  { value: 'sunPowerSolutions', name: 'SunPower Solutions' },
  { value: 'greenEnergyInstallers', name: 'Green Energy Installers' },
  { value: 'solarTechSystems', name: 'Solar Tech Systems' },
  { value: 'brightFutureSolar', name: 'Bright Future Solar' },
];

export const serialNumberOperatorOptions: SelectOption[] = [
  { value: 'exact', name: 'Exact Match' },
  { value: 'contains', name: 'Contains' },
  { value: 'range', name: 'Range' },
];

export const equipmentFirmwareVersionOperatorOptions: SelectOption[] = [
  { value: 'exactly', name: 'Exactly' },
  { value: 'olderThan', name: 'Older than' },
  { value: 'newerThan', name: 'Newer than' },
];

export const onlineStatusOptions: SelectOption[] = [
  { value: 'online', name: 'Online' },
  { value: 'offline', name: 'Offline' },
];

export const signalStrengthOptions: SelectOption[] = [
  { value: 'unusable', name: 'Unusable' },
  { value: 'notGood', name: 'Not Good' },
  { value: 'okay', name: 'Okay' },
  { value: 'veryGood', name: 'Very Good' },
  { value: 'excellent', name: 'Excellent' },
  { value: 'hardwired', name: 'Hardwired' },
];

export const equipmentQuantityOperatorOptions: SelectOption[] = [
  { value: 'exactly', name: 'Exactly' },
  { value: 'lessThan', name: 'Less than' },
  { value: 'moreThan', name: 'More than' },
];
